import React from 'react';
import { Button, Card, Modal } from 'react-bootstrap';
import { FaCheckCircle, FaCrown, FaEnvelope, FaPhone } from 'react-icons/fa';

const TrialExpiredModal = ({ show, onHide, onUpgrade }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      className="trial-expired-modal"
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="w-100 text-center">
          <FaCrown className="text-warning mb-2" size={40} />
          <h3>Trial Period Expired</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        <p className="text-center text-muted mb-4">
          Your free trial has ended. Upgrade now to continue using all features and maintain your audit compliance.
        </p>
        
        <div className="row g-4">
          <div className="col-md-6">
            <Card className="h-100 shadow-sm">
              <Card.Body className="p-4">
                <h5 className="mb-3">Why Upgrade?</h5>
                <ul className="list-unstyled">
                  {[
                    'Unlimited audit templates',
                    'Priority support',
                    'Advanced analytics',
                    'Custom reporting',
                    'Team collaboration'
                  ].map((feature, index) => (
                    <li key={index} className="mb-2">
                      <FaCheckCircle className="text-success me-2" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-6">
            <Card className="h-100 border-primary shadow-sm">
              <Card.Body className="p-4">
                <h5 className="text-primary mb-3">Professional Plan</h5>
                <div className="mb-3">
                  <span className="h2">$49</span>
                  <span className="text-muted">/month</span>
                </div>
                <p className="text-muted mb-4">
                  Everything you need for professional audit management
                </p>
                <Button 
                  variant="primary" 
                  size="lg" 
                  className="w-100 mb-3"
                  onClick={onUpgrade}
                >
                  Upgrade Now
                </Button>
              </Card.Body>
            </Card>
          </div>
        </div>
        
        {/* Contact Information Section */}
        <div className="mt-4 text-center">
          <h5 className="mb-3">Need Help? Contact Us</h5>
          <div className="d-flex align-items-center justify-content-center mb-2">
            <FaEnvelope className="text-primary me-2" />
            <span>info@valuecraftminds.com</span>
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <FaPhone className="text-primary me-2" />
            <span>+94 76 020 06320</span>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 justify-content-center">
        <Button variant="link" onClick={onHide} className="text-muted">
          Maybe Later
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TrialExpiredModal;